import { createResource } from 'react-resource-router';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { getCompressionRatio } from '../endpoint';
const emptyCompressionBanner = {
  compressionRatio: 0,
  uniqueGroupCount: 0,
  rollingWindow: 0
};
export const compressionRatioResource = createResource({
  type: 'compressionRatioResource',
  getKey: () => 'compressionRatioResource',
  getData: async () => {
    try {
      if (getBooleanFF('platform.aiops-smart-view_yf5qp')) {
        const response = await getCompressionRatio();
        return response;
      } else {
        return emptyCompressionBanner;
      }
    } catch (e) {
      return emptyCompressionBanner;
    }
  },
  maxAge: 5 * 60 * 1000,
  // 5 minutes
  isBrowserOnly: true
});